
import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const Services = () => {
  return (
    <Container className="my-5">
      <h1 className="text-center mb-4">Our Services</h1>
      <Row>
        <Col md={4} className="mb-4">
          <Card>
            <Card.Body>
              <Card.Title>Wealth Management</Card.Title>
              <Card.Text>
                Our primary focus is the preservation and growth of your wealth. We create bespoke strategies that align with your long-term aspirations.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4} className="mb-4">
          <Card>
            <Card.Body>
              <Card.Title>Investment Advisory</Card.Title>
              <Card.Text>
                Leverage our global market insights and rigorous analysis to build a resilient and diversified investment portfolio.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4} className="mb-4">
          <Card>
            <Card.Body>
              <Card.Title>Estate & Trust Planning</Card.Title>
              <Card.Text>
                Secure your legacy with our expert guidance on estate planning, trust formation, and intergenerational wealth transfer.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Services;
